import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const Contactus = async (data) => {
  try {
    return await postData(`/website/contactus/add`, data);
  } catch (error) {
    console.log(error);
  }
};
